export default __webpack_public_path__ + "static/media/solidrums2.b8456265.png";